import React from 'react';

const footerLinks = [
  { label: 'Terms & Conditions', href: '/terms' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'CCPA', href: '/ccpa' },
  { label: 'support@adsmash.com', href: 'mailto:support@adsmash.com' },
];

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-[#050512] text-gray-300" role="contentinfo">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-6 py-12 md:px-12">
        <div className="flex flex-col gap-10 border-b border-white/10 pb-10 md:flex-row md:items-start md:justify-between">
          <div className="flex flex-col items-center gap-3 text-center md:items-start md:text-left">
            <img
              src="/images/logo.png"
              alt="AdSmash logo"
              className="h-8 w-auto md:h-10"
            />
            <p className="max-w-sm text-sm text-gray-400">
              AdSmash keeps your browsing experience fast, private, and distraction-free
              with premium blocking technology built for modern users.
            </p>
          </div>

          <div className="flex flex-col items-start text-left text-sm">
            <div className="mt-3 flex flex-col gap-2">
              {footerLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-gray-300 transition-colors hover:text-primary-400 text-left"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="text-center text-sm text-gray-400 md:text-right">
            <p className="text-white">AdSmash HQ</p>
            <p>1200 Market Street</p>
            <p>Suite 230</p>
            <p>San Francisco, CA 94102</p>
          </div>
        </div>

        <div className="text-center text-xs text-gray-500">
          © {year} AdSmash. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;

